<template>
  <div class="card" :class="{
  'disabled has-background-grey-light' : sectionDisabled
  }" v-if="section.name">
    <div class="card-header">
      <div class="column">
        <div class="columns">
          <div class="column">
            <b-icon icon="arrows-up-down-left-right" />
            Convocatorias
          </div>
          <div class="column has-text-right">
            Mostrar sección:
            <b-switch :aria-disabled="sectionDisabled" :disabled="sectionDisabled" v-model="section.announcements.active" @input="updateSection" />
          </div>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns">
        <div class="column">
          <b-field>
            <b-input 
              v-model="section.announcements.title" 
              placeholder="Título de la convocatoria" 
              @blur="updateSection"
              disabled = "sectionDisabled"
              :class="{'disabled-input': sectionDisabled}"
            />
          </b-field>
          <b-field>
            <b-input 
              v-model="section.announcements.subtitle" 
              placeholder="Subtítulo de la convocatoria" 
              @blur="updateSection"
              disabled = "sectionDisabled"
              :class="{'disabled-input': sectionDisabled}"
            />
          </b-field>
          <b-field>
            <b-input 
              v-model="section.announcements.description" 
              type="textarea"
              placeholder="Descripción de la convocatoria" 
              @blur="updateSection"
              :disabled = "sectionDisabled"
              :class="{'disabled-input': sectionDisabled}"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field v-if="!isLoading">
            <b-upload v-model="section.announcements.file" drag-drop accept="image/*"
              @input="uploadLocalImage($event, section)" :disabled = "sectionDisabled">
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large">
                    </b-icon>
                  </p>
                  <p>Da click o arrastra el archivo que deseas subir</p>
                  <p>La imagen debe medir 438px x 497px</p>
                </div>
              </section>
            </b-upload>
          </b-field>

          <div class="loading-wrapper" v-else>
            <b-loading :active="isLoading"  :is-full-page="false"/>
          </div>
        </div>
      </div>
      <div class="tags" v-if="section.announcements.image?.url">
        <span class="tag is-primary">
          {{ section.announcements.image.name }}
          <button class="delete is-small" type="button" @click="deleteLocalImage(section)">
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    defaultSection: {
      type: Object,
    },
    uploadImage: {
      type: Function,
    },
    deleteImage: {
      type: Function,
    },
    sectionDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      section: {},
      isLoading: false,
    }
  },
  mounted() {
    this.section = {...this.defaultSection};
  },
  watch: {
    defaultSection: {
      handler: function (val) {
        this.section = {...val }
      }
    },
  },
  methods: {
    updateSection() {
      this.$emit('updateSection', this.section)
    },
    async uploadLocalImage(e, section){
      this.isLoading = true;
      const file = e;
      const fileIdentifier = section.name;
      const fileMetadata = section[section.name].image;
      section[section.name].image = await this.uploadImage(file, fileIdentifier, fileMetadata);

      this.updateSection();
      this.isLoading = false;
    },
    async deleteLocalImage(section){
      this.isLoading = true;
      section[section.name].image = await this.deleteImage(section[section.name].image.key);

      this.updateSection();
      this.isLoading = false;
    },
  }
}
</script>

<style scoped>
.loading-wrapper{
    position: relative;
    min-height: 300px;
  }
</style>
